import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'achoo-index-status',
  templateUrl: './achoo-index-status.component.html',
  styleUrls: ['./achoo-index-status.component.scss']
})
export class AchooIndexStatusComponent implements OnInit {

  @Input() status: string;
  @Input() value: number;
  @Input() color = '#FFFFFF';


  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-index-status/achoo-index-status.component.ts